import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue";
import _imports_0 from '../assets/imgs/log.png';
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "common-layout"
};
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = {
  class: "loginout"
};
const _hoisted_5 = {
  style: {
    "margin-right": "30px",
    "color": "#111111"
  }
};
const _hoisted_6 = {
  style: {
    "color": "#999999"
  }
};
const _hoisted_7 = {
  class: "main-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_link = _resolveComponent("el-link");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "header-box"
    }, {
      default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "left"
      }, [_createElementVNode("img", {
        src: _imports_0,
        class: "logo"
      })], -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "center"
      }, [_createElementVNode("div", {
        class: "title"
      }, "智汇零售运营管理平台")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString(_ctx.userInfo.username) + " ", 1), _createElementVNode("span", _hoisted_6, " ( " + _toDisplayString(_ctx.userInfo.appRole == 1 ? '管理员' : _ctx.userInfo.appRole == 2 ? '运营商' : '点位') + " )", 1)]), _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _ctx.loginOut && _ctx.loginOut(...args))
      }, [_createVNode(_component_el_link, {
        type: "primary",
        underline: false
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("退出")])),
        _: 1
      })])])])]),
      _: 1
    }), _createVNode(_component_el_container, null, {
      default: _withCtx(() => [_createVNode(_component_el_aside, {
        width: "220px",
        class: "el-aside"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_scrollbar, {
          always: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_menu, {
            "active-text-color": "#ffd04b",
            "background-color": "#545c64",
            class: "el-menu-vertical-demo",
            router: "",
            "default-active": _ctx.activeMenu,
            "text-color": "#fff"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, item => {
              return _openBlock(), _createBlock(_component_el_sub_menu, {
                index: item.path,
                key: item.path
              }, {
                title: _withCtx(() => [_createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))]),
                  _: 2
                }, 1024), _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)]),
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, items => {
                  return _openBlock(), _createBlock(_component_el_menu_item_group, {
                    key: items.path
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_menu_item, {
                      index: items.path
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(items.meta.icon)))]),
                        _: 2
                      }, 1024), _createElementVNode("span", null, _toDisplayString(items.name), 1)]),
                      _: 2
                    }, 1032, ["index"])]),
                    _: 2
                  }, 1024);
                }), 128))]),
                _: 2
              }, 1032, ["index"]);
            }), 128))]),
            _: 1
          }, 8, ["default-active"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_main, null, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_breadcrumb, {
          "separator-icon": _ctx.ArrowRight,
          style: {
            "cursor": "pointer",
            "margin": "10px 0",
            "display": "inline-block",
            "margin-left": "10px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadList, item => {
            return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
              to: item.path,
              key: item.id
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.meta.title), 1)]),
              _: 2
            }, 1032, ["to"]);
          }), 128))]),
          _: 1
        }, 8, ["separator-icon"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_router_view)])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })])]);
}